import { useEffect, useRef, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form/dist/index.ie11';
import { ReportingOption } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';
import { getReportingRequirements } from 'src/components/enterprise/features/Corporate/components/Form/BulkUploadEmployeeWrapper/bulkUploadEmployeeWrapper.utils';

export type UseBulkUploadEmployeeReturnType = {
  disableRequirementOptions: boolean;
};

export function useBulkUploadEmployeeWrapper(): UseBulkUploadEmployeeReturnType {
  const isReportingDirty = useRef(false);
  const { setValue, formState } = useFormContext();
  const { reporting } = useWatch({
    name: ['reporting'],
  });

  useEffect(() => {
    if (formState.dirtyFields?.reporting) {
      // eslint-disable-next-line better-mutation/no-mutation
      isReportingDirty.current = true;
    }
  }, [formState.dirtyFields?.reporting]);

  useEffect(() => {
    /**
     * Prevents resetting location/department requirements when editing an existing corp
     * unless the reporting field is explicitly modified by the user
     */
    if (!isReportingDirty.current) {
      return;
    }

    const { dinerLocationRequired, dinerDepartmentRequired } =
      getReportingRequirements(reporting);

    setValue('dinerLocationRequired', dinerLocationRequired);
    setValue('dinerDepartmentRequired', dinerDepartmentRequired);
  }, [reporting, setValue]);

  const disableRequirementOptions = useMemo(() => {
    return reporting !== ReportingOption.NONE_REPORTING_OPTION;
  }, [reporting]);

  return {
    disableRequirementOptions,
  };
}
